<template>
  <el-dialog
    title="编辑补单类型"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form size="small">
      <el-form-item label="所属分类" :label-width="formLabelWidth">
        <el-select v-model="typeLabel">
          <el-option label="顶级分类" value="0"></el-option>
          <el-option
            :value="cat.id"
            :label="cat.name"
            :key="cat.id"
            v-for="cat in editform.catList"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="分类名称"
        prop="typeName"
        :label-width="formLabelWidth"
      >
        <el-input v-model="typeName" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editType" :loading="loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import OrderApi from "@/api/order.js";
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      typeLabel: "0", //上级id
      /*左边长度*/
      formLabelWidth: "120px",
      typeName: "",
      id: "" //分类id
    };
  },
  props: ["open_edit", "editform"],
  created() {
    this.dialogVisible = this.open_edit;

    this.typeLabel =  this.editform.model.pid==0?'0':this.editform.model.pid;
    this.id = this.editform.model.id;
    this.typeName = this.editform.model.name;
    console.log(this.open_edit, this.editform, "--------");
  },
  methods: {
    // 编辑类型
    editType() {
      let self = this;
      self.loading = true;
      let params = {
        name: self.typeName,
        pid: self.typeLabel,
        id:self.id
      };
      self.loading = true;
      OrderApi.editRepairOrderType(params)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "添加成功",
            type: "success"
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style scoped lang="sass"></style>



// WEBPACK FOOTER //
// src/views/order/supplement/Edit.vue